import { memo } from 'react';

import Container from '@mui/material/Container';
import PropTypes from 'prop-types';

const AppContainer = memo(function AppContainer({
  children,
  maxWidth = 'lg',
  disableGutters = false,
  ...rest
}) {
  return (
    <Container maxWidth={maxWidth} disableGutters={disableGutters} {...rest}>
      {children}
    </Container>
  );
});

AppContainer.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  disableGutters: PropTypes.bool,
};

export default AppContainer;
